export enum PromotionalApplyStatusEnum {
    Success = 1,
    Failed = 2,
    NotApplied = 3
}
